export const COUNTRIES = [
  { code: "MX", name: "México", phoneCode: "+52", phoneDigits: 10, flag: "🇲🇽" },
  { code: "US", name: "Estados Unidos", phoneCode: "+1", phoneDigits: 10, flag: "🇺🇸" },
  { code: "CA", name: "Canadá", phoneCode: "+1", phoneDigits: 10, flag: "🇨🇦" },
  { code: "AR", name: "Argentina", phoneCode: "+54", phoneDigits: 10, flag: "🇦🇷" },
  { code: "BR", name: "Brasil", phoneCode: "+55", phoneDigits: 11, flag: "🇧🇷" },
  { code: "CL", name: "Chile", phoneCode: "+56", phoneDigits: 9, flag: "🇨🇱" },
  { code: "CO", name: "Colombia", phoneCode: "+57", phoneDigits: 10, flag: "🇨🇴" },
  { code: "GT", name: "Guatemala", phoneCode: "+502", phoneDigits: 8, flag: "🇬🇹" },
  { code: "PE", name: "Perú", phoneCode: "+51", phoneDigits: 9, flag: "🇵🇪" },
  { code: "VE", name: "Venezuela", phoneCode: "+58", phoneDigits: 10, flag: "🇻🇪" },
  { code: "ES", name: "España", phoneCode: "+34", phoneDigits: 9, flag: "🇪🇸" },
  { code: "DE", name: "Alemania", phoneCode: "+49", phoneDigits: 11, flag: "🇩🇪" },
  { code: "GB", name: "Reino Unido", phoneCode: "+44", phoneDigits: 10, flag: "🇬🇧" },
];

export const getCountryByCode = (code) => {
  return COUNTRIES.find(c => c.code === code);
};

export const getCountryByPhoneCode = (phoneCode) => {
  return COUNTRIES.find(c => c.phoneCode === phoneCode);
};

export const formatPhoneWithCountry = (phone, countryCode) => {
  const country = getCountryByCode(countryCode);
  if (!country) return phone;
  
  const digitsOnly = phone.replace(/\D/g, '');
  return `${country.phoneCode}${digitsOnly}`;
};

export const normalizePhone = (phone, countryCode) => {
  const country = getCountryByCode(countryCode);
  if (!country) return phone;
  
  const digitsOnly = phone.replace(/\D/g, '');
  // Si ya incluye el código de país, solo retorna
  if (digitsOnly.startsWith(country.phoneCode.replace(/\D/g, ''))) {
    return digitsOnly;
  }
  // Si no, agrega el código
  return `${country.phoneCode.replace(/\D/g, '')}${digitsOnly}`;
};

export const extractPhoneWithoutCountryCode = (phone, countryCode) => {
  if (!phone) return '';
  
  const country = getCountryByCode(countryCode);
  if (!country) return phone.replace(/\D/g, '');
  
  const digitsOnly = phone.replace(/\D/g, '');
  const countryCodeDigits = country.phoneCode.replace(/\D/g, '');
  
  // Casos especiales para México (521) y Argentina (549)
  if (countryCode === 'MX' && digitsOnly.startsWith('521')) {
    return digitsOnly.slice(3);
  }
  if (countryCode === 'AR' && digitsOnly.startsWith('549')) {
    return digitsOnly.slice(3);
  }
  
  // Para otros países, quitar el código de país estándar si está presente
  if (digitsOnly.startsWith(countryCodeDigits)) {
    return digitsOnly.slice(countryCodeDigits.length);
  }
  
  return digitsOnly;
};
